export default "__VITE_PUBLIC_ASSET__00c6a351__"